import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Início' },
    { path: '/catalogo', label: 'Catálogo' },
    { path: '/marcas', label: 'Marcas' },
    { path: '/sobre', label: 'Sobre' },
    { path: '/contato', label: 'Contato' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50 border-b-2 border-gray-200">
      {/* Top Bar - Esconde horário no mobile */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 py-2 border-b border-gray-200">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-2">
            <Mail size={14} className="text-blue-900" />
            <a href={`mailto:${companyInfo.email}`} className="text-gray-700 hover:text-blue-900 transition-colors font-medium text-xs md:text-sm">
              {companyInfo.email}
            </a>
          </div>
          <div className="hidden md:block text-xs text-gray-600 font-medium">
            {companyInfo.hours}
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/logo-casa-das-ferramentas.svg" 
              alt="Casa das Ferramentas"
              className="h-12 md:h-14 w-auto object-contain group-hover:scale-105 transition-transform bg-transparent"
              style={{ background: 'transparent' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-2.5 rounded-lg font-bold text-sm tracking-wide transition-all ${
                  isActive(link.path)
                    ? 'bg-blue-900 text-white shadow-lg'
                    : 'text-gray-700 hover:text-blue-900 hover:bg-gray-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/orcamento">
              <Button className="ml-4 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-black shadow-lg hover:shadow-xl hover:scale-105 transition-all">
                Solicitar Orçamento
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2.5 hover:bg-gray-100 rounded-xl transition-all text-gray-700"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-2 animate-fade-in">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-5 py-3 rounded-xl font-bold transition-all ${
                  isActive(link.path)
                    ? 'bg-blue-900 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/orcamento" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-black mt-3 shadow-xl">
                Solicitar Orçamento
              </Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};
